// extracted by mini-css-extract-plugin
module.exports = {"container":"errorBlock_container__M-M7x"};
    if(module.hot) {
      // 1785568536644
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  